<template>
  <div class="rentalContractConfirmModal">
    <BsModal
      ref="rentalContractConfirmModalRef"
      :modal-dialog-settings="['modal-xl']"
    >
      <!-- header -->
      <template v-slot:header>
        <h5 class="modal-title" id="rentalContractConfirmModalLabel">
          <span v-if="confirmTypes.registration">登録確認</span>
          <span v-else-if="confirmTypes.complete">完了確認</span>
        </h5>
      </template>
      <!-- ./header -->
      <!-- body -->
      <div class="mb-3">
        <Registration v-if="confirmTypes.registration" />
        <Complete v-else-if="confirmTypes.complete" />
      </div>
      <!-- ./body -->
      <!-- footer -->
      <template v-slot:footer>
        <button
          type="button"
          class="btn btn-secondary"
          @click="closeRentalContractConfirmModal()"
        >
          キャンセル
        </button>
        <button
          type="button"
          class="btn btn-primary"
          @click="clickSubmitButton()"
        >
          登録
        </button>
      </template>
      <!-- ./footer -->
    </BsModal>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";
import { BsModal } from "bs-modal-vue";
import { rentalContractConfirmModalRef } from "../../compositions/script/submitRentalContract";
import {
  closeRentalContractConfirmModal,
  clickSubmitButton,
  confirmTypes,
} from "../../compositions/script/submitRentalContract";
import Registration from "../confirm/RentalContractRegistration.vue";
import Complete from "../confirm/RentalContractComplete.vue";
export default defineComponent({
  components: {
    BsModal,
    Registration,
    Complete,
  },
  setup() {
    rentalContractConfirmModalRef.value = ref<any>(null);

    return {
      /* Function */
      closeRentalContractConfirmModal,
      clickSubmitButton,
      /* Variables */
      rentalContractConfirmModalRef,
      confirmTypes,
    };
  },
});
</script>
